<template>
  <div style="display:flex; justify-content: space-between;">
    <div>
      <h5 style="display: inline;" class="card-title mb-0">
        {{ title }}
        <slot></slot>
        <small style="font-weight:600; color:#20a8d8">
          {{ dateFrom }}
          <b v-if="dateFrom">|</b>
          {{ dateTo }}
        </small>
      </h5>
    </div>
    <div v-if="productGroups || backProductGroups">
      <b-button
        v-if="productGroups"
        @click="emitFunction"
        class="btn-outline btn-sm ml-3"
        variant="outline-primary"
        right
      >
        Product Groups
      </b-button>
      <b-button
        v-if="backProductGroups"
        @click="emitFunction"
        class="btn-outline btn-sm ml-3"
        variant="outline-primary"
        right
      >
        Back
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderTitle",
  props: [
    "title",
    "dateFrom",
    "dateTo",
    "productGroups",
    "productGroupsEmit",
    "backProductGroups"
  ],
  methods: {
    emitFunction() {
      this.$emit(this.productGroupsEmit);
    }
  }
};
</script>
